import { TypeGroupIds } from "../constants/category-groupid.constants";

export enum Status {
    Active = 1,
    InActive = 2,
    Deleted = 3
}

export enum AddressTypeId {
    BILLING = 38,
    SHIPPING = 39,
    OTHER = 40
}

export enum AccountGroupId {
    ID = TypeGroupIds.AccountTypeAccountAPI
};

export enum TabIndex {
   OVERVIEW = 0,
   CONTACT = 1,
   TASK = 2
};
